// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__v5qeU","inputWrap":"styles_inputWrap__27086","input":"styles_input__3pI_B"};